import React, {useMemo} from 'react';
import {StyleSheet, View} from 'react-native';
import {MenuIconType} from 'src/components/elements/newui/SettingsMenuOption';
import BlockedSnackUsersIcon from 'src/components/img/svg/settingsMenu/BlockedSnackUsersIcon';
import ChangeEmailIcon from 'src/components/img/svg/settingsMenu/ChangeEmailIcon';
import ChangePinIcon from 'src/components/img/svg/settingsMenu/ChangePinIcon';
import DeleteAccountIcon from 'src/components/img/svg/settingsMenu/DeleteAccountIcon';
import HelpIcon from 'src/components/img/svg/settingsMenu/HelpIcon';
import LinkLocationIcon from 'src/components/img/svg/settingsMenu/LinkLocationIcon';
import PersonalInfoIcon from 'src/components/img/svg/settingsMenu/PersonalInfoIcon';
import ReceiptsIcon from 'src/components/img/svg/settingsMenu/ReceiptsIcon';
import ReferralIcon from 'src/components/img/svg/settingsMenu/ReferralIcon';
import ScanKioskQrCodeIcon from 'src/components/img/svg/settingsMenu/ScanKioskQrCodeIcon';
import ScanMarketCardIcon from 'src/components/img/svg/settingsMenu/ScanMarketCardIcon';
import SendASnackIcon from 'src/components/img/svg/settingsMenu/SendASnackIcon';
import ViewPrivacyPolicyIcon from 'src/components/img/svg/settingsMenu/ViewPrivacyPolicyIcon';
import ViewTermsConditionIcon from 'src/components/img/svg/settingsMenu/ViewTermsConditionIcon';
import WalletIcon from 'src/components/img/svg/settingsMenu/WalletIcon';
import Styles from 'src/components/Styles';

const SettingsMenuIcon = (type: MenuIconType) => {
  const menuIcon = useMemo(() => {
    switch (type) {
      case MenuIconType.Snack:
        return <SendASnackIcon />;
      case MenuIconType.Referral:
        return <ReferralIcon />;
      case MenuIconType.Wallet:
        return <WalletIcon />;
      case MenuIconType.Receipts:
        return <ReceiptsIcon />;
      case MenuIconType.ScanMarketCard:
        return <ScanMarketCardIcon />;
      case MenuIconType.ScanKioskQrCode:
        return <ScanKioskQrCodeIcon />;
      case MenuIconType.Help:
        return <HelpIcon />;
      case MenuIconType.ChangeEmail:
        return <ChangeEmailIcon />;
      case MenuIconType.ChangePin:
        return <ChangePinIcon />;
      case MenuIconType.PersonalInfo:
        return <PersonalInfoIcon />;
      case MenuIconType.LinkLocation:
        return <LinkLocationIcon />;
      case MenuIconType.BlockedSnackUsers:
        return <BlockedSnackUsersIcon />;
      case MenuIconType.ViewPrivacyPolicy:
        return <ViewPrivacyPolicyIcon />;
      case MenuIconType.DeleteAccount:
        return <DeleteAccountIcon />;
      case MenuIconType.ViewTermsCondition:
      case MenuIconType.SendLogsToDeveloper:
        return <ViewTermsConditionIcon />;
      default:
        return null;
    }
  }, [type]);

  return <View style={styles.iconContainer}>{menuIcon}</View>;
};

const styles = StyleSheet.create({
  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: Styles.Spacing.m2,
  },
});

export default SettingsMenuIcon;
